'use client'

import React, { useState, useEffect } from 'react'
import styles from './TerminalTabs.module.css'
import Holdings from './Holdings'

interface OpenOrder {
  time: string
  side: 'BUY' | 'SELL'
  limitPrice: number
  size: number
  symbol: string
  stopLoss: number
  takeProfit: number
}

const TABS = ['Open Orders', 'Order History', 'Trade History', 'Holdings']

export default function TerminalTabs() {
  const [activeTab, setActiveTab] = useState<string>(TABS[0])
  const [openOrders, setOpenOrders] = useState<OpenOrder[]>([])
  const [isLoading, setIsLoading] = useState(false)

  // Fetch open orders when component mounts
  useEffect(() => {
    const fetchOpenOrders = async () => {
      setIsLoading(true)
      try {
        const response = await fetch('/api/openorders')
        if (!response.ok) throw new Error('Failed to fetch orders')
        const data = await response.json()
        setOpenOrders(data)
      } catch (error) {
        console.error('Error fetching open orders:', error)
      } finally {
        setIsLoading(false)
      }
    }

    fetchOpenOrders()
  }, [])

  const renderOpenOrders = () => {
    if (isLoading) return <div>Loading orders...</div>
    if (openOrders.length === 0) return <div>No open orders</div>

    return (
      <div className={styles.ordersTable}>
        <table>
          <thead>
            <tr>
              <th>Time</th>
              <th>Symbol</th>
              <th>Side</th>
              <th>Size</th>
              <th>Limit Price</th>
              <th>Stop Loss</th>
              <th>Take Profit</th>
            </tr>
          </thead>
          <tbody>
            {openOrders.map((order, index) => (
              <tr key={index}>
                <td>{order.time}</td>
                <td>{order.symbol.toUpperCase()}</td>
                <td
                  className={
                    order.side === 'BUY' ? styles.buyOrder : styles.sellOrder
                  }
                >
                  {order.side}
                </td>
                <td>{order.size}</td>
                <td>₹{order.limitPrice}</td>
                <td>₹{order.stopLoss}</td>
                <td>₹{order.takeProfit}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )
  }

  const renderTabContent = () => {
    switch (activeTab) {
      case 'Open Orders':
        return renderOpenOrders()
      case 'Order History':
        return <div>Order history data goes here...</div>
      case 'Trade History':
        return <div>Trade history data goes here...</div>
      case 'Holdings':
        return <Holdings />
      default:
        return null
    }
  }

  return (
    <div className={styles.tabsContainer}>
      <ul className={styles.tabList}>
        {TABS.map(tab => (
          <li
            key={tab}
            className={`${styles.tabItem} ${
              tab === activeTab ? styles.activeTab : ''
            }`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </li>
        ))}
      </ul>
      <div className={styles.tabContent}>{renderTabContent()}</div>
    </div>
  )
}
